import { defineMessages } from "react-intl"
import facilLimpieza from "../img/facil-limpieza.svg"
import impermeabilidad from "../img/impermeabilidad.svg"
import abrasion from "modules/pranna/components/ProductDetails/img/abrasion.svg"
import retardanciaFuego from "../img/retardancia-fuego.svg"
import durabilidadColor from "../img/durabilidad-color.svg"

export const MSGS = defineMessages({
  facilLimpieza: {
    id: "Pranna.ProductDetail.easyCleaning",
    description: "Pranna section product detail item easy cleaning",
    defaultMessage: "Fácil {br} Limpieza"
  },
  impermeabilidad: {
    id: "Pranna.ProductDetail.impermeability",
    description: "Pranna section product detail item impermeability",
    defaultMessage: "Impermeabilidad"
  },
  retardanciaFuego: {
    id: "Pranna.ProductDetail.flameRetardancy",
    description: "Pranna section product detail item flame retardancy",
    defaultMessage: "Retardancia {br} Al Fuego"
  },
  resistenciaUV: {
    id: "Pranna.ProductDetail.resistenciaUV",
    description: "Pranna section product detail item color durability",
    defaultMessage: "Resistencia {br} a los rayos U.V"
  },
  abrasion: {
    id: "Pranna.ProductDetail.abrationRetardancy",
    description: "Pranna section product detail item abration retardancy",
    defaultMessage: "Resistencia {br} a la Abrasión"
  }
})

export const PRODUCT_DETAILS = [
  {
    id: "facilLimpieza",
    text: MSGS.facilLimpieza,
    icon: facilLimpieza
  },
  {
    id: "impermeabilidad",
    text: MSGS.impermeabilidad,
    icon: impermeabilidad
  },
  {
    id: "retardanciaFuego",
    text: MSGS.retardanciaFuego,
    icon: retardanciaFuego
  },
  {
    id: "resistenciaUV",
    text: MSGS.resistenciaUV,
    icon: durabilidadColor
  },
  {
    id: "abrasion",
    text: MSGS.abrasion,
    icon: abrasion
  }
]
